import Observable from "zen-observable";
import {ajax} from "@timgroup/common-javascript-components";
import {Clock} from "js-joda";

export function observeDelay(delaySeconds) {
    return observeDelayMillis(delaySeconds * 1000);
}

export function observeDelayMillis(delayMillis) {
    return new Observable(observer => {
        let timer = setTimeout(() => {
            timer = null;
            observer.complete();
        }, delayMillis);

        return () => {
            if (timer) clearTimeout(timer);
        };
    });
}

export function repeat(intervalSeconds, clock = Clock.systemDefaultZone()) {
    return underlying => {
        return new Observable(observer => {
            let subscription = null;
            let timer = null;

            // FIXME tests rely on initial load being executed synchronously

            function doFetch(isInitial = false) {
                const startTime = clock.millis();
                subscription = underlying.subscribe(
                    ({ data, code, xhr }) => {
                        observer.next({ data, error: false, code, xhr, startTime, isInitial });
                    },
                    ({ code, xhr }) => {
                        observer.next({ data: null, error: true, code, xhr, startTime, isInitial });
                        subscription = null;
                        if (isInitial) scheduleSubsequent();
                    },
                    () => {
                        subscription = null;
                        if (isInitial) scheduleSubsequent();
                    }
                );
            }

            function scheduleSubsequent() {
                timer = setInterval(() => {
                    if (!subscription) {
                        doFetch();
                    }
                }, intervalSeconds * 1000);
            }

            doFetch(true);

            return () => {
                if (timer) clearInterval(timer);
                if (subscription) subscription.unsubscribe();
            }
        });
    }
}

export function observeApi(url, intervalSeconds, initialWaitMillis, clock = Clock.systemDefaultZone()) {
    const fetchObservable = repeat(intervalSeconds, clock)(ajax.get(url));
    return initialWaitMillis > 0 ? observeDelayMillis(initialWaitMillis).concat(fetchObservable) : fetchObservable;
}
